/* Generated by scripts/build-css.ts. DO NOT EDIT. */

/**
 * Duration (in ms) of each generic motion, mirroring the `--animate-*` CSS
 * tokens. Pass the matching value as `exitDurationMs` to {@link PresenceOne} /
 * {@link PresenceList} so the exit timer matches the CSS animation.
 */
export const animationDurationsMs = {
  slide: 600,
  collapse: 800,
  disclose: 250,
  progress: 600,
  fade: 300,
  fast: 200,
  caret: 1000,
  pulse: 2000,
} as const;
